var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"avatar",class:{'has-border': _vm.border},style:({
  width: _vm.width+'px',
  height: _vm.height+'px',
  padding: _vm.border +1+ 'px'
})},[_c('div',{staticClass:"img-container"},[_c('img',{attrs:{"src":_vm.avatar,"alt":"avatar"}}),_c('div',{staticClass:"facial-mask"})]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }